import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import TagManager from "react-gtm-module";
import { BrowserRouter } from "react-router-dom";

const tagManagerArgs = {
  gtmId: "GTM-MZ88ZHPN",
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);